// extracted by mini-css-extract-plugin
export default {"calculator":"calculator_calculator__hQKwT","container":"calculator_container__bL1RI","results":"calculator_results__DKceo","bottom":"calculator_bottom__RfPOm"};